import { CurrencyRequests } from '@/services/currency.requests'
const currencyService = new CurrencyRequests()

const state = {
  list: [],
  modifiedList: [],
  modifiedCurrencyList: []
}
const getters = {
  modifiedList: state => state.modifiedList,
  modifiedCurrencyList: state => state.modifiedCurrencyList
}

const actions = {
  list ({ state, commit }) {
    return new Promise((resolve, reject) => {
      currencyService.list().then((currencies) => {
        state.list = currencies
        commit('modifiedList')
        commit('modifiedCurrencyList')
        resolve(currencies)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  postpaid ({}, { accountId, currencyId }) {
    return new Promise((resolve, reject) => {
      currencyService.postpaid(accountId, currencyId).then(() => {
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  modifiedList (state) {
    state.modifiedList = state.list.map(currency => {
      currency['disabled'] = false
      return currency
    })
  },
  modifiedCurrencyList (state) {
    state.modifiedCurrencyList = JSON.parse(JSON.stringify(state.modifiedList))
  },
  setModifiedCurrencyList (state, modifiedCurrencyList) {
    state.modifiedCurrencyList = modifiedCurrencyList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
